import { Tag } from 'antd';
import {
  ClockCircleOutlined,
  LoadingOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  HourglassOutlined
} from '@ant-design/icons';

// Stage R1: small status pill rendered in lists + detail headers.
// One source of truth for the colour/icon per `status` so the
// jobs table and the viewer header always agree.

const STATUS_META = {
  queued:    { color: 'blue',     icon: <ClockCircleOutlined />, label: 'Queued' },
  running:   { color: 'gold',     icon: <LoadingOutlined />,     label: 'Running' },
  completed: { color: 'green',    icon: <CheckCircleOutlined />, label: 'Completed' },
  failed:    { color: 'red',      icon: <CloseCircleOutlined />, label: 'Failed' },
  cancelled: { color: 'default',  icon: <StopOutlined />,        label: 'Cancelled' },
  expired:   { color: 'default',  icon: <HourglassOutlined />,   label: 'Expired' }
};

export default function ReportJobStatus({ status }) {
  const meta = STATUS_META[status] || STATUS_META.queued;
  return (
    <Tag color={meta.color} icon={meta.icon}>
      {meta.label}
    </Tag>
  );
}
